import * as React from 'react';

export type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  invalid?: boolean;
  focusOnRender?: boolean;
  allowRevealedPassword?: boolean;
  revealed?: boolean;
};

import { Button } from './button';
import { EyeOff, Eye } from 'lucide-react';
import { Input } from './input';

export const PasswordInput = React.forwardRef((props: Props, ref) => {
  const {
    invalid,
    focusOnRender,
    revealed: propsRevealed,
    allowRevealedPassword,
    ...inputProps
  } = props;

  const [revealed, setRevealed] = React.useState(propsRevealed || false);

  return (
    <div className="flex gap-2 items-center">
      <Input
        type={revealed ? 'text' : 'password'}
        autoFocus={focusOnRender}
        variant={invalid ? 'destructive' : 'default'}
        ref={ref as any}
        {...inputProps}
      />

      {allowRevealedPassword && (
        <Button
          onClick={() => setRevealed(!revealed)}
          variant="ghost"
          size="icon"
          type="button"
        >
          {revealed ? (
            <EyeOff className="PasswordInput-eye" />
          ) : (
            <Eye className="PasswordInput-eye" />
          )}
        </Button>
      )}
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';
